module.exports = __webpack_public_path__ + "static/media/hot74.d81d1564.jpg";